import { Check } from "lucide-react";

export const PROPERTY_TYPES = [
  { v: "appartement", l: "Appartement" },
  { v: "maison", l: "Maison" },
  { v: "villa", l: "Villa" },
  { v: "studio", l: "Studio" },
  { v: "autre", l: "Autre (gîte, chalet…)" },
];

export const RENTAL_STATUS = [
  { v: "deja_loue", l: "Déjà en location", d: "Je veux changer ou déléguer la gestion" },
  { v: "pas_encore", l: "Pas encore loué", d: "Je veux me lancer en location courte durée" },
  { v: "projet_achat", l: "Projet d'achat", d: "J'étudie un investissement" },
];

export const RENTAL_MODES = [
  { v: "toute_annee", l: "Toute l'année" },
  { v: "saisonnier", l: "En saison" },
  { v: "occasionnel", l: "Quand je ne l'occupe pas" },
];

export const SERVICES = [
  "Gestion complète",
  "Création de l'annonce et photos",
  "Accueil et remise des clés",
  "Ménage et linge",
  "Prix dynamiques",
  "Messages voyageurs",
  "Petite maintenance",
  "Déclarations et taxe de séjour",
];

export const TIMINGS = [
  { v: "asap", l: "Dès que possible" },
  { v: "1_3_mois", l: "Sous 1 à 3 mois" },
  { v: "plus_tard", l: "Plus tard / je me renseigne" },
];

export function Choice({ active, onClick, title, desc, testid, center }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`p-4 rounded-2xl border-2 transition-colors flex items-center justify-between gap-3 ${center ? "text-center justify-center" : "text-left"} ${
        active ? "border-accent bg-accent/5" : "border-border hover:border-accent/50"
      }`}
    >
      <span>
        <span className="block font-semibold">{title}</span>
        {desc && <span className="block text-xs text-muted-foreground mt-0.5">{desc}</span>}
      </span>
      {!center && (
        <span className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${active ? "bg-accent text-accent-foreground" : "border-2 border-border"}`}>
          {active && <Check size={12} strokeWidth={3} />}
        </span>
      )}
    </button>
  );
}

export function StepTitle({ index, total, title, hint }) {
  return (
    <div>
      <div className="text-xs font-bold text-accent uppercase tracking-widest">Étape {index} / {total}</div>
      <h2 className="h-card mt-2 text-2xl md:text-3xl">{title}</h2>
      {hint && <p className="text-muted-foreground mt-2 text-sm">{hint}</p>}
    </div>
  );
}

export function Counter({ label, value, min, max, onChange, testid }) {
  return (
    <div className="flex items-center justify-between p-4 rounded-2xl border-2 border-border">
      <span className="font-semibold">{label}</span>
      <div className="flex items-center gap-3">
        <button type="button" onClick={() => onChange(Math.max(min, value - 1))} className="w-9 h-9 rounded-full border border-border hover:border-accent font-bold" data-testid={`${testid}-minus`}>−</button>
        <span className="w-8 text-center font-bold text-xl" data-testid={`${testid}-value`}>{value}</span>
        <button type="button" onClick={() => onChange(Math.min(max, value + 1))} className="w-9 h-9 rounded-full border border-border hover:border-accent font-bold" data-testid={`${testid}-plus`}>+</button>
      </div>
    </div>
  );
}

export const inputCls =
  "w-full px-5 py-3.5 border border-input rounded-full bg-background focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-accent";
